import React, { useEffect, useRef, useState, useCallback } from "react";
import { Box, HStack, VStack } from "@chakra-ui/layout";
import { withErrorBoundary } from "../errorBoundary";
import { IVideosProps, IVideoProp } from "./videos.types";
import spinnerIcon from '../../assets/images/spinner.gif';
import axios from "axios";

const getVideoData = (item: any, downloadUrl: any) => {
  const durationInSeconds = item.duration; // Duration is already in seconds
  if (durationInSeconds > 1200) { // 20 minutes in seconds
    throw new Error("Video duration exceeds 20 minutes.");
  }

  return {
    downloadUrl: downloadUrl,
    url: item.url,
    width: item.width,
    height: item.height,
    thumbnail: item.image,
    duration: item.duration,
  };
};

export function Videos({
  videos: rawVideos,
  onItemSelectedCb,
  onSelectedTemUrlCb,
  itemSelected,
  itemSelectedUrl,
  getPexelsPhotoData,
  onDragStart,
  onDragEnd
}: IVideosProps) {
  const [selectedData, setSelectedData] = useState(0);
  const [count, setCount] = useState(0);
  const sides: any[][] = [[], []];
  const heightsSum = [0, 0];
  const [isLoading, setIsLoading] = useState(false)

  let videos: any = [];
  try {
    videos = rawVideos.map((element: any) => {
      return getVideoData(element, element.video_files[0].link)
    });
  } catch (error) {
    console.log(error);
  }

  for (const video of videos) {
    if (heightsSum[0] < heightsSum[1]) {
      sides[0].push(video);
      heightsSum[0] += video.height / video.width;
    } else {
      sides[1].push(video);
      heightsSum[1] += video.height / video.width;
    }
  }

  const onSelectedItemClick = useCallback(
    (event: any, counter: any) => {
      setCount(counter);
      setSelectedData(0);
    },
    [selectedData, count]
  );

  const itemClick = async(e: any) => {
    
    try {
    setIsLoading(true)
      const response  = await axios.post('https://plugin-pixabay-api.ssemble.com/upload', {
        url: e.target.src
      })

    const returnJson = {
      action: "create",
      type: "video",
      file: response.data,
      thumbnail: itemSelectedUrl.thumbnail
    };

    getPexelsPhotoData(returnJson);
    setIsLoading(false)

    if (window.vlogr) {
      window.vlogr.addData(1, JSON.stringify(returnJson));
    }
    if (window.webkit) {
      window.webkit.messageHandlers.addData.postMessage(returnJson);
    }
    if (window.top) {
      window.top.postMessage(returnJson, "*");
    }
  } catch (error) {
      console.info(error)
      setIsLoading(false)
  }
  };

  return (
    <Box marginInline="auto" maxWidth="fit-content" style={{ opacity: `${ isLoading ? '0.5': '' }` }}>
      <HStack spacing="8px" align="start">
      { isLoading && <img style={{ position: 'fixed', marginTop: '50%', left: '50%', zIndex: 999,  transform: 'translate(-50%, -50%)', }} src={spinnerIcon} height={50} width={50} /> }
        <VStack maxW="50%" spacing="8px">
          {sides[0] &&
            sides[0].length &&
            sides[0].map((urls: any, i) => {
              return (
                <Box key={i} position="relative" onClick={itemClick}>
                  <Video
                    urls={urls}
                    onSelectedItemClick={onSelectedItemClick}
                    selectedData={selectedData}
                    setSelectedData={setSelectedData}
                    count={count}
                    onItemSelectedCb={onItemSelectedCb}
                    onSelectedTemUrlCb={onSelectedTemUrlCb}
                    itemSelected={itemSelected}
                    itemSelectedUrl={itemSelectedUrl}
                    onDragStart={(event: React.DragEvent<HTMLDivElement>) => {
                      if (onDragStart) {
                        onDragStart(event, {
                          action: "create",
                          type: "video",
                          file: urls.downloadUrl,
                        });
                      }
                    }}
                    onDragEnd={(
                      event: React.DragEvent<HTMLDivElement>,
                      data: any
                    ) => {
                      onDragEnd(event, data);
                    }}
                  />
                </Box>
              );
            })}
        </VStack>
        <VStack maxW="50%" spacing="8px">
          {sides[1] &&
            sides[1].length &&
            sides[1].map((urls: any, i) => {

              return (
                <Box key={i} position="relative" onClick={itemClick}>
                  <Video
                    urls={urls}
                    onSelectedItemClick={onSelectedItemClick}
                    selectedData={selectedData}
                    setSelectedData={setSelectedData}
                    count={count}
                    onItemSelectedCb={onItemSelectedCb}
                    onSelectedTemUrlCb={onSelectedTemUrlCb}
                    itemSelected={itemSelected}
                    itemSelectedUrl={itemSelectedUrl}
                    onDragStart={(event: React.DragEvent<HTMLDivElement>) => {
                      if (onDragStart) {
                        onDragStart(event, {
                          action: "create",
                          type: "video",
                          file: urls.downloadUrl,
                        });
                      }
                    }}
                    onDragEnd={(
                      event: React.DragEvent<HTMLDivElement>,
                      data: any
                    ) => {
                      onDragEnd(event, data);
                    }}
                  />
                </Box>
              );
            })}
        </VStack>
      </HStack>
    </Box>
  );
}

export const VideosWithErrorBoundary = withErrorBoundary<IVideosProps>(Videos);

const Video = ({
  urls,
  onSelectedItemClick,
  selectedData,
  setSelectedData,
  count,
  onItemSelectedCb,
  onSelectedTemUrlCb,
  itemSelected,
  itemSelectedUrl,
  onDragStart,
  onDragEnd
}: IVideoProp) => {
  const [isSelected, setSelected] = useState<boolean>(selectedData);
  const playerRef: any = useRef(null);
  const pVidRef = useRef(null);

  useEffect(() => {
    if (count >= 1) {
      onSelectedItemClick(null, 0);
      playerRef.current && playerRef.current.pause();
      setSelected(selectedData);
    }
  }, [isSelected, count]);

  useEffect(() => {
    if (!itemSelected && itemSelectedUrl.item_url == "") {
      setSelectedData(false);
      playerRef.current && playerRef.current.pause();
      setSelected(selectedData);
      onSelectedItemClick(null, 0);
    }
  }, [isSelected, selectedData, count, itemSelected, itemSelectedUrl]);

  const handleClick = (e: any) => {
    let counter = count + 1;
    onSelectedItemClick(e, counter);
    setTimeout(() => {
      let url = e.target.src;
      //@ts-ignore
      playerRef.current && playerRef.current.play();
      onSelectedTemUrlCb({ item_url: url, item_type: "video" });
      setSelected(true);
      onItemSelectedCb(true);
    }, 50);
  };

  const handleVideoPlay = (e: any) => {
    e.preventDefault();
    playerRef.current.pause();
  };

  return (
    <div
      ref={pVidRef}
      className={isSelected ? "sDiv" : "mDiv"}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        e.preventDefault();
        handleClick(e);
      }}
    >
      
      <video
        ref={playerRef}
        poster={urls.thumbnail}
        src={urls.downloadUrl}
        muted
        controls={false}
        disableRemotePlayback={true}
        onPlay={handleVideoPlay}
        onDragStart={(event) => {
          if (onDragStart) {
            onDragStart(event);
          }
        }}
        onDragEnd={(event) => {
          if (onDragEnd) {
            onDragEnd(event, {
              client: {
                x: event.clientX,
                y: event.clientY,
              },
              screen: {
                x: event.screenX,
                y: event.screenY,
              },
              page: {
                x: event.pageX,
                y: event.pageY,
              },
              movement: {
                x: event.movementX,
                y: event.movementY,
              },
            });
          }
        }}
      />
    </div>
  );
};